import { SectionTitle } from "../../components/common/SectionTitle";

type StoryViewProps = {
  title: string;
  image: string;
  imageAlt: string;
  paragraphs: readonly string[];
};

export function StoryView({ title, image, imageAlt, paragraphs }: StoryViewProps) {
  return (
    <section id="historia" className="section story">
      <SectionTitle title={title} />
      <div className="banner-media">
        <img
          src={image}
          alt={imageAlt}
          className="banner-image"
          loading="lazy"
          decoding="async"
          width={1170}
          height={640}
          sizes="(max-width: 640px) 100vw, (max-width: 1200px) 88vw, (max-width: 1800px) 72vw, 1100px"
        />
      </div>
      <div className="story-text">
        {paragraphs.map(paragraph => (
          <p key={paragraph}>{paragraph}</p>
        ))}
      </div>
    </section>
  );
}
